// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  --padding-start: 0px;
  border: 1px solid black;
}

ion-datetime {
  max-width: 100%;
  overflow-y: auto;
}

.date-picker-container .value-label {
  padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/date-time-picker/date-time-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAGE;EACE,iBAAA;AAAJ","sourcesContent":["ion-item {\r\n  --padding-start: 0px;\r\n  border: 1px solid black;\r\n}\r\n\r\nion-datetime {\r\n  max-width: 100%;\r\n  overflow-y:auto;\r\n}\r\n\r\n.date-picker-container {\r\n  .value-label {\r\n    padding-left: 5px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
